const listName = localStorage.getItem('AP_SELECTED_LIST')
const listId = localStorage.getItem('AP_SELECTED_LIST_ID')
const userEmail = localStorage.getItem('AP_USER_EMAIL')

export default {
  header: {
    views: '0',
    downloads: '0',
    email: userEmail,
    isPaidUser: false,
    linkedinFollow: false,
    canShowLinkedinFollow: false,
    lbCreditsPlan: false,
    credits: '0',
    phoneCredits: 0,
    userType: '',
    name: '',
    mobileNumberEnabled: false
  },
  dockModeType: 'right-dock', // All options = (right-dock = normal-mode)  / (left-dock = lead-mode) / (pin-dock = pin-mode)
  isDockSettingsAvailable: false,
  liData: null,
  isSalesNavigator: false,
  isCRMExportEnabled: false,
  linkedin: {
    autoTrigger: false,
    bulk: { contacts: null, unique_id: null },
    list: {
      selectedList: listName ? listName : 'Plugin History',
      selectedListId: listId ? listId : null
    }
  },
  salesgear: {
    salesgearBanner: false,
    isDupContact: false,
    expContactType: 'duplicate',
    isContactLimit: false,
    showConnectEmail: false,
    contactOwnerName: '',
    showSalesgearPromotion: false,
    showSalesgearExportOption: true,
    customFields: {}
  },
  showMaintenanceScreen: false,
  enableSalesNavigatorCompany: false
}
